import React, { useContext, useEffect, useState } from "react";
import { Card } from "../ui/card";
import { Bell, CheckCircle, XCircle, Clock, Calendar, ArrowRight } from "lucide-react";
import { ApiContext } from "src/context/ApiContext.jsx";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { toast } from "react-toastify";

const NotificationPage = () => {

  const { user, updateUser } = useContext(ApiContext);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  useEffect(() => {
    if (user?.notifications) {
      setNotifications([...user.notifications].reverse());
      setLoading(false);
    }
  }, [user]);

  const markAsRead = async (notificationId) => {
    try {
      // Update locally first for instant UI feedback
      setNotifications(prev => prev.map(n => 
        n._id === notificationId ? {...n, seen: true} : n
      ));
      
      // API call to mark as read
      // await api.patch(`/notifications/${notificationId}/read`);
      toast.success("Marked as read");
    } catch (error) {
      toast.error("Failed to update notification");
      console.error(error);
    }
  };

  const markAllAsRead = async () => {
    try {
      setNotifications(prev => prev.map(n => ({...n, seen: true})));
      // await api.patch('/notifications/mark-all-read');
      toast.success("All notifications marked as read");
    } catch (error) {
      toast.error("Failed to update notifications");
      console.error(error);
    }
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'completed': return <CheckCircle className="w-4 h-4 text-green-500" />;
      case 'cancelled': return <XCircle className="w-4 h-4 text-red-500" />;
      default: return <Clock className="w-4 h-4 text-blue-500" />;
    }
  };

  const handleNotificationClick = (notification) => {
    markAsRead(notification._id);
    if (notification.booking) {
      navigate(`/bookings/${notification.booking}`);
    }
  };

  if (notifications?.length === 0){
    return(
    <div className="flex justify-center items-center h-64">
    <p>No new notifications</p>
  </div>
    )
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  console.log("notifications : " , notifications)

  return (
    <div className="max-w-2xl my-44 mx-auto p-4 md:p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold flex items-center justify-center gap-2">
          <Bell className="w-6 h-6 text-blue-600" />
          Notifications
        </h2>
        {/* {notifications.some(n => !n.seen) && (
          <Button 
            variant="ghost" 
            onClick={markAllAsRead}
            className="text-blue-600 hover:bg-blue-50"
          >
            Mark all as read
          </Button>
        )} */}
      </div>

      {notifications.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12">
          <Bell className="w-12 h-12 text-gray-400 mb-4" />
          <p className="text-gray-500 text-lg">No notifications yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {notifications.map((notification) => (
            <Card
              key={notification._id}
              // onClick={() => handleNotificationClick(notification)}
              className={`p-4 transition-all cursor-pointer hover:shadow-md ${
                !notification.seen ? "bg-blue-50 border-l-4 border-blue-500" : "bg-white"
              }`}
            >
              <div className="flex justify-between items-start gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    {getStatusIcon(notification.status)}
                    <p className={`font-medium ${
                      !notification.seen ? "text-gray-900" : "text-gray-600"
                    }`}>
                      {notification.message}
                    </p>
                  </div>
                  
                  {notification.booking && (
                    <div className="flex items-center gap-2 text-sm text-gray-500 mt-2">
                      <Calendar className="w-4 h-4" />
                      <span>{formatDate(notification.date)}</span>
                      <span>•</span>
                      <span>Booking ID: {notification.booking}</span>
                    </div>
                  )}
                </div>
                {/* <ArrowRight className="w-5 h-5 text-gray-400" /> */}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationPage;